<div
  class="justify-center rounded-3xl shadow-md cursor-pointer hover:shadow-lg hover:scale-105 transition-transform duration-300 ease-in-out relative">
  <a (click)="showDescription(scormPackage)" class="block no-underline m-0 p-0">
    <div class="flex flex-col p-0 bg-black rounded-3xl h-[220px] relative">
      @if (shouldShowProgressionIcon(scormPackage)) {
        <span class="absolute top-2 right-2 z-10">
          @if (scormPackage.progression === EProgressionPaquet.EnCours) {
            <span
              class="flex items-center justify-center rounded-full bg-blue-500 w-9 h-9 shadow-md border-2 border-white">
              <mat-icon style="color:white; font-size: 1.5rem; line-height: 1;">pause</mat-icon>
            </span>
          }
          @if (scormPackage.progression === EProgressionPaquet.Complete) {
            <span
              class="flex items-center justify-center rounded-full bg-green-500 w-9 h-9 shadow-md border-2 border-white">
              <mat-icon style="color:white; font-size: 1.5rem; line-height: 1;">check</mat-icon>
            </span>
          }
        </span>
      }
      <div class="flex-grow flex rounded-2xl mr-0 ml-0 mt-0 mb-0 h-[154px] overflow-visible">
        <img alt="img" class="w-full h-full object-cover rounded-t-[22px]"
          [src]="getLocalizedContent(scormPackage.locales).thumbnail"
          [alt]="getLocalizedContent(scormPackage.locales).titre + ' thumbnail'">
        </div>
        <div
          class="w-full h-[66px] flex items-center justify-start px-3 footer-card transition-all duration-300 ease-in-out">
          <span style="font-weight: 400; font-size: 1rem; line-height: 1.3;"
          class="text-white text-left leading-tight">{{getLocalizedContent(scormPackage.locales).titre}}</span>
        </div>
      </div>
    </a>
  </div>